import React, { useEffect, useState } from 'react';
import { DocPreviewModal } from './DocPreviewModal';
import { downloadDocument } from './VersicherungCard';

/** Einmal in App gemountet: öffnet Dokumente (Versicherungsschein, Energieausweis …) als In-App-Vorschau statt Download. */
export const GlobalDocPreview = () => {
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    const onOpen = (e) => setDoc(e.detail);
    window.addEventListener('hv:doc-preview', onOpen);
    return () => window.removeEventListener('hv:doc-preview', onOpen);
  }, []);
  if (!doc) return null;
  return (
    <DocPreviewModal doc={doc} token={localStorage.getItem('token')} onClose={() => setDoc(null)}
      onDownload={(d) => downloadDocument(d.id, d.name)} />
  );
};

export default GlobalDocPreview;
